import React from 'react';

const LoginPage = () => (
  <div style={{ padding: '2rem', textAlign: 'center' }}>
    <h1>Login</h1>
    <p>Bitte melden Sie sich an.</p>
  </div>
);

export default LoginPage;
